/* eslint-disable camelcase */
/* eslint-disable no-redeclare */
/* eslint-disable block-scoped-var */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-named-as-default-member */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import {
  CREATE_MASTERCLASS_CERTIFICATE,
  DELETE_MASTERCLASS_CERTIFICATE,
  GET_MASTERCLASS_CERTIFICATE,
  UPDATE_MASTERCLASS_CERTIFICATE,
} from '../../types/masterclass/masterclassCertificateTypes';

import { axiosPut, del, get, post } from '../../../ApiConfig';
import {
  createMasterclassCertificateFailed,
  createMasterclassCertificateSuccessful,
  deleteMasterclassCertificateFailed,
  deleteMasterclassCertificateSuccessful,
  getMasterclassCertificates,
  getMasterclassCertificatesFailed,
  getMasterclassCertificatesSuccessful,
  updateMasterclassCertificateFailed,
  updateMasterclassCertificateSuccessful,
} from './actions';

// get_masterclass_certificate
const getMasterclassCertificatesAsync = () => {
  return get(
    `/admin/course/course/certificate/all`,
    { params: { page: 1, limit: 1000 } },
    { notifyError: true }
  );
};
function* GetMasterclassCertificates() {
  try {
    const response = yield call(getMasterclassCertificatesAsync);
    yield put(getMasterclassCertificatesSuccessful({ data: response.data }));
  } catch (error) {
    yield put(getMasterclassCertificatesFailed({ error, data: [] }));
  }
}

// create_masterclass_certificate
const createMasterclassCertificateAsync = (payload) => {
  return post(
    '/admin/course/course/certificate',
    payload,
    {},
    { notify: true }
  );
};
function* CreateMasterclassCertificate({ payload: { onSuccess, ...payload } }) {
  try {
    const response = yield call(createMasterclassCertificateAsync, payload);
    yield put(createMasterclassCertificateSuccessful(response.data));
    onSuccess?.(response.data);
    yield put(getMasterclassCertificates());
  } catch (error) {
    yield put(createMasterclassCertificateFailed(error));
  }
}

// update_masterclass_certificate
const updateMasterclassCertificateAsync = ({ id, ...payload }) => {
  return axiosPut(
    `/admin/course/course/certificate/${id}`,
    payload,
    {},
    { notify: true }
  );
};
function* UpdateMasterclassCertificate({ payload: { onSuccess, ...payload } }) {
  try {
    const response = yield call(updateMasterclassCertificateAsync, payload);
    yield put(updateMasterclassCertificateSuccessful(response.data));
    onSuccess?.(response.data);
    yield put(getMasterclassCertificates());
  } catch (error) {
    yield put(updateMasterclassCertificateFailed(error));
  }
}

// delete_masterclass_certificate
const deleteMasterclassCertificateAsync = (id) => {
  return del(`/admin/course/course/certificate/${id}`, {}, { notify: true });
};
// delete_masterclass_certificate
function* DeleteMasterclassCertificate({ payload }) {
  try {
    const response = yield call(deleteMasterclassCertificateAsync, payload);
    yield put(deleteMasterclassCertificateSuccessful(response.data));
    yield put(getMasterclassCertificates());
  } catch (error) {
    yield put(deleteMasterclassCertificateFailed(error));
  }
}

export function* watchMasterclass() {
  yield takeLatest(GET_MASTERCLASS_CERTIFICATE, GetMasterclassCertificates);
  yield takeLatest(
    CREATE_MASTERCLASS_CERTIFICATE,
    CreateMasterclassCertificate
  );
  yield takeLatest(
    UPDATE_MASTERCLASS_CERTIFICATE,
    UpdateMasterclassCertificate
  );
  yield takeLatest(
    DELETE_MASTERCLASS_CERTIFICATE,
    DeleteMasterclassCertificate
  );
}

export default function* rootSaga() {
  yield all([fork(watchMasterclass)]);
}
